<template>
    <div>
		<div class="dropdown-menu remove-style" aria-labelledby="dropdownMenuButton">
			<a class="dropdown-item" style="cursor:pointer" :disabled="(selectedProducts.length <1)" @click="selectedBulkAction='Add Tag';productActionChanged()">Update Status</a>
		</div>
		<div v-if = "(showCannotDel && selectedProducts.length)"><p style = "color : red"> {{'Cannot Delete ' + cannotDelArray + ' as part of campaign'}}</p>
		</div>
		  <AddTags
		  		@closeModal = "closeTagModal"
		  />
    </div>
</template>

<script>

import AddTags from '@/components/product-alerts/UpdateStatus'
import ProductListGridFooter from '@/components/product-alerts/IssueListFooter'

export default {
    name: 'IssueListAction',
    data() {
        return {
            selectedBulkAction: 'Action',
			showCannotDel : false,
			cannotDelArray : [],
			cannotHideArray : [],
        }
    },
	components : {
		AddTags,
		ProductListGridFooter,
	},
    computed: {
        selectedProducts: {
            set(val) {
				this.showCannotDel = false
				this.cannotDelArray = []
				this.cannotHideArray = []
                this.$store.state.product.selectedProducts = val
            },
            get() {
                return this.$store.state.product.selectedProducts;
            }
        },
		actionSelectionControl: {
			set(val) {
				this.$store.state.product.actionSelectionControl = val
			},
			get() {
				return this.$store.state.product.actionSelectionControl
			}
		},
    },
    methods: {
        productActionChanged() {
				$("#updateWorkStatus").modal('show');
	
        },
		closeTagModal(type){
			console.log('ATTEMPTING TO CLOSE MODAL')

			$('#updateWorkStatus').modal('hide');
			$('.modal').modal('hide');
			$('body').removeClass('modal-open');
			$('.modal-backdrop').remove();
			this.selectedBulkAction =  'Action';
			// this.$router.go()
		}
    }
}
</script>

<style lang="scss">
</style>
